import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { UnidadeNegocioLinhaProducaoComponent } from './unidade-negocio-linha-producao.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        UnidadeNegocioLinhaProducaoComponent
    ],
    exports: [
        UnidadeNegocioLinhaProducaoComponent
    ]
})
export class UnidadeNegocioLinhaProducaoModule { }
